const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const API = `${API_BASE}/api/v1`;
export const MEDIA_URL = API_BASE;
